import { render, staticRenderFns } from "./vipComparison.vue?vue&type=template&id=6e61fc42&scoped=true"
import script from "./vipComparison.vue?vue&type=script&lang=js"
export * from "./vipComparison.vue?vue&type=script&lang=js"
import style0 from "./vipComparison.vue?vue&type=style&index=0&id=6e61fc42&prod&lang=scss&scoped=true"
import style1 from "./vipComparison.vue?vue&type=style&index=1&id=6e61fc42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e61fc42",
  null
  
)

export default component.exports